
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/product/[productId]",
      function () {
        return require("private-next-pages/product/[productId].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/product/[productId]"])
      });
    }
  